import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackOpenInMobileAppClicked.meta';

export type OpenInMobileAppLocation = 'help_menu' | 'mobile_nav' | 'banner';

export type UseTrackOpenInMobileAppClickedParams = {
  location: OpenInMobileAppLocation;
};

export const useTrackOpenInMobileAppClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackOpenInMobileAppClicked = useCallback(
    (params: UseTrackOpenInMobileAppClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackOpenInMobileAppClicked };
};
